<nz-drawer
    [nzClosable]="true"
    [nzBodyStyle]="{ overflow: 'auto' }"
    [nzVisible]="visible"
    nzPlacement="right"
    [nzMask]="false"
    [nzMaskClosable]="true"
    [nzCloseOnNavigation]="false"
    [nzWrapClassName]="'debug-drawer'"
    (nzOnClose)="closed.emit()">
    <ng-container *nzDrawerContent>
        <div class="flex flex-col">
            <div class="px-3 pb-5">
                <h2>Debug</h2>
                <h4>
                    Lead Number:
                    <strong>{{ leadNumber }}</strong>
                </h4>
                @for (section of sections; track $index) {
                    <div>
                        <div (click)="toggleAccordion($index)">
                            <h3>
                                {{ openAccordions[$index] ? '-' : '+' }}
                                {{ section.label }}
                            </h3>
                        </div>
                        @if (openAccordions[$index]) {
                            <ngx-json-viewer
                                [json]="section.state()"
                                [expanded]="false"></ngx-json-viewer>
                        }
                    </div>
                }
            </div>
            <div class="bg-sub-1 z-10 bottom-0">
                <base-container [hasBottomPadding]="false">
                    <div class="py-3 justify-content">
                        <button
                            (click)="onClickLogToExceptionless()"
                            class="fu-btn-primary"
                            nz-button
                            nzSize="large"
                            nzType="default">
                            Log to exceptionless
                        </button>
                    </div>
                </base-container>
            </div>
        </div>
    </ng-container>
</nz-drawer>
